import { reverseRecord } from 'osn-shared';
import { RecommendationBecauseYouWatchedRecency } from '../../create-tray-screen/components/recommendation-tray-form/recommendation-tray-form.view-model';

export const becauseYouWatchedRecencyDomainToApi: Record<RecommendationBecauseYouWatchedRecency, number> = {
  [RecommendationBecauseYouWatchedRecency.Latest]: 1,
  [RecommendationBecauseYouWatchedRecency.Second]: 2,
  [RecommendationBecauseYouWatchedRecency.Third]: 3,
};

export const becauseYouWatchedRecencyApiToDomain = reverseRecord(becauseYouWatchedRecencyDomainToApi);
